import { Image } from 'expo-image';
import * as Updates from 'expo-updates';
import { SafeAreaView } from 'react-native-safe-area-context';

import { not_found } from '@/assets/images';
import { Header } from '@/components/header';
import { Button, ButtonText } from '@/components/ui/button';
import { Heading } from '@/components/ui/heading';
import { useColors } from '@/hooks/useColors';

export default function NotFoundScreen() {
  const { colors } = useColors();

  return (
    <SafeAreaView className="flex-1 items-center justify-center px-5 py-8" edges={['bottom']}>
      <Header title="Oops!" headerShown={false} statusBarBackgroundColor={colors.background[0]} />

      <Image
        alt="not found"
        source={not_found}
        contentFit="contain"
        style={{ height: 257, width: 257, marginBottom: 32 }}
      />
      <Heading size="h1-xl" className="mb-6">
        This screen does not exist
      </Heading>

      <Button
        className="w-full"
        onPress={() => {
          Updates.reloadAsync();
        }}>
        <ButtonText>Take me home</ButtonText>
      </Button>
    </SafeAreaView>
  );
}
